module.exports = __webpack_public_path__ + "static/media/logo_small.4d04495e.svg";